<template>
  <div>
    <TableColumnSelector
      :show="showTableColumnSelector"
      @hide="showTableColumnSelector = false"
      v-model="headers"
      :skip="['actions']"
    ></TableColumnSelector>
    <v-btn @click="onClickNew"><v-icon>mdi-plus</v-icon>
    {{ $t("button.new") }}
    </v-btn>
    <v-data-table
      class="table"
      :headers="selectedHeaders"
      :items="projects"
      :items-per-page="10"
      :server-items-length="total"
      :loading="loading"
      :loading-text="$t('projects.table.loading')"
      disable-filtering
      disable-sort
      :footer-props="footerProps"
      :options.sync="options"
      @click:row="onClick"
    >
      <template v-slot:item.created="{ item }">
        {{ item.created | formatDate }}
      </template>
      <template v-slot:item.owner="{ item }">
        {{ owner(item.owner).username }}
      </template>
      <template v-slot:item.last_updated="{ item }">
        {{ item.last_updated | formatDate }}
      </template>
      <template v-slot:header.actions="{}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              small
              @click.stop.prevent="showTableColumnSelector = true"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>
            {{ $t("components.tableColumnSelector.tooltip") }}
          </span>
        </v-tooltip>
      </template>
    </v-data-table>
    <add-dialog v-model="dialog"></add-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import AddDialog from "@/components/projects/AddDialog";
import {
  ACTION_SET_CURRENT_PROJECT,
  LIST,
  LOAD_PROJECTS,
  SET_CURRENT_PROJECT,
  TOTAL
} from "@/store/modules/project";
import { FIND } from "@/store/modules/user";
import {
  TABLE_HEADER_PROJECT_LIST,
  TABLE_HEADER_SLIDE_MANAGEMENT
} from "@/constants";
import TableColumnSelector from "@/components/TableColumnSelector";

export default {
  data: () => ({
    dialog: false,
    options: undefined,
    showTableColumnSelector: false
  }),
  computed: {
    ...mapGetters({
      projects: LIST,
      total: TOTAL,
      owner: FIND
    }),
    ...mapState({
      keycloak: state => state.authentication.keycloak,
      loading: state => state.project.loading
    }),
    footerProps() {
      return {
        "items-per-page-options": [5, 10, 15],
        "items-per-page-text": this.$t("projects.table.footerText")
      }
    },
    headers() {
      return [
        { text: this.$t("projects.table.id"), value: "id", visible: false },
        { text: this.$t("projects.table.name"), value: "project_name", visible: true },
        { text: this.$t("projects.table.status"), value: "status", visible: false },
        { text: this.$t("projects.table.owner"), value: "owner", visible: false },
        { text: this.$t("projects.table.created"), value: "created", visible: true },
        { text: this.$t("projects.table.lastUpdated"), value: "last_updated", visible: false },
        { text: "", value: "actions", visible: true }
      ]
    },
    selectedHeaders() {
      return this.headers.filter(e => e.visible);
    }
  },
  watch: {
    headers: {
      deep: true,
      handler(val) {
        this.$dp.store(TABLE_HEADER_PROJECT_LIST, val, true);
      }
    },
    options(newVal, oldVal) {
      // do not search if rendered the first time
      if (oldVal) {
        if (
          newVal.itemsPerPage !== oldVal.itemsPerPage ||
          newVal.page !== oldVal.page
        ) {
          this.$store.dispatch(LOAD_PROJECTS, newVal);
        }
      }
    }
  },
  methods: {
    onClick(project) {
      if (
        !this.keycloak.tokenParsed.projects
          .split(",")
          .includes(project.id.toString())
      ) {
        this.$router.push({ name: "401" });
        return;
      }
      this.$store.dispatch(ACTION_SET_CURRENT_PROJECT, { project });
      this.$router.push({ name: "project", params: { id: project.id } });
    },
    onClickNew() {
      this.dialog = true;
    }
  },
  mounted() {
    this.$store.commit(SET_CURRENT_PROJECT, {});
  },
  created() {
    this.$store.dispatch(LOAD_PROJECTS, undefined);
  },
  components: { AddDialog, TableColumnSelector }
};
</script>
<style lang="css" scoped></style>
